import React from 'react';
import NotifyControl2 from './NotifyControl2';
import { Typography } from "@mui/material";
import { Card } from "react-bootstrap";
import { FormattedMessage, injectIntl } from "react-intl";

class NotifyArea2 extends React.Component {
    render() {
        return (
            <div style={{ marginTop: 20 }}>
                <Typography style={{ marginLeft: 16 }} variant="h6" component="div" gutterBottom>
                    {this.props.title}
                </Typography>
                <div style={{ display: 'flex', flexDirection: 'column', width: '100%', padding: '10px', border: '1px solid #ccc', borderRadius: '10px' }}>


                    <Card style={{ marginBottom: 10 }}>
                        <Card.Header as="h5"><FormattedMessage id='OPTIONS.ACTIONS.GRP_1' /> </Card.Header>
                        <Card.Body>
                            {
                                this.props.actionsObj.GRP_1.subGroups.map((item, index) => (
                                    <NotifyControl2
                                        key={this.props.skey + "GRP_1_" + index}
                                        skey={this.props.skey + "GRP_1_" + index}
                                        actionsObj={item}
                                        contract={this.props.contract}
                                        contractTemplate={this.props.contractTemplate}
                                    />
                                ))
                            }
                        </Card.Body>
                    </Card>
                    <Card style={{ marginBottom: 10 }}>
                        <Card.Header as="h5"><FormattedMessage id='OPTIONS.ACTIONS.GRP_2' /></Card.Header>
                        <Card.Body>
                            {
                                this.props.actionsObj.GRP_2.subGroups.map((item, index) => (
                                    <NotifyControl2
                                        key={this.props.skey + "GRP_2_" + index}
                                        skey={this.props.skey + "GRP_2_" + index}
                                        actionsObj={item}
                                        contract={this.props.contract}
                                        contractTemplate={this.props.contractTemplate}
                                    />
                                ))
                            }
                        </Card.Body>
                    </Card>
                    <Card style={{ marginBottom: 10 }}>
                        <Card.Header as="h5"><FormattedMessage id='OPTIONS.ACTIONS.GRP_3' /></Card.Header>
                        <Card.Body>
                            {
                                this.props.actionsObj.GRP_3.subGroups.map((item, index) => (
                                    <NotifyControl2
                                        key={this.props.skey + "GRP_3_" + index}
                                        skey={this.props.skey + "GRP_3_" + index}
                                        actionsObj={item}
                                        contract={this.props.contract}
                                        contractTemplate={this.props.contractTemplate}
                                    />
                                ))
                            }
                        </Card.Body>
                    </Card>
                    <Card style={{ marginBottom: 10 }}>
                        <Card.Header as="h5"><FormattedMessage id='OPTIONS.ACTIONS.GRP_4' /></Card.Header>
                        <Card.Body>
                            {
                                this.props.actionsObj.GRP_4.subGroups.map((item, index) => (
                                    <NotifyControl2
                                        key={this.props.skey + "GRP_4_" + index}
                                        skey={this.props.skey + "GRP_4_" + index}
                                        actionsObj={item}
                                        contract={this.props.contract}
                                        contractTemplate={this.props.contractTemplate}
                                    />
                                ))
                            }
                        </Card.Body>
                    </Card>
                    <Card style={{ marginBottom: 10 }}>
                        <Card.Header as="h5"><FormattedMessage id='OPTIONS.ACTIONS.GRP_5' /></Card.Header>
                        <Card.Body>
                            {
                                this.props.actionsObj.GRP_5.subGroups.map((item, index) => (
                                    <NotifyControl2
                                        key={this.props.skey + "GRP_5_" + index}
                                        skey={this.props.skey + "GRP_5_" + index}
                                        actionsObj={item}
                                        contract={this.props.contract}
                                        contractTemplate={this.props.contractTemplate}
                                    />
                                ))
                            }
                        </Card.Body>
                    </Card>
                    <Card style={{ marginBottom: 10 }}>
                        <Card.Header as="h5"><FormattedMessage id='OPTIONS.ACTIONS.GRP_6' /></Card.Header>
                        <Card.Body>
                            {
                                this.props.actionsObj.GRP_6.subGroups.map((item, index) => (
                                    <NotifyControl2
                                        key={this.props.skey + "GRP_6_" + index}
                                        skey={this.props.skey + "GRP_6_" + index}
                                        actionsObj={item}
                                        contract={this.props.contract}
                                        contractTemplate={this.props.contractTemplate}
                                    />
                                ))
                            }
                        </Card.Body>
                    </Card>


                </div>
            </div>
        );
    }
}

export default NotifyArea2;